import { StackSpacing } from "app/shared/components/spacing";
import { ACCOUNT } from "app/shared/services/services-model.type";
import { formatCurrency } from "app/shared/util/format-currency";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { GestureResponderEvent, Pressable } from "react-native";
import { useTheme } from "react-native-paper";
import Animated, { interpolateColor, useAnimatedStyle } from "react-native-reanimated";

interface TermScrollProps {
  item?: ACCOUNT;
  onPressItem?: (event: GestureResponderEvent) => void;
  animationValue: Animated.SharedValue<number>;
}

const TermScroll = (props: TermScrollProps) => {
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();

  const { item = undefined, onPressItem, animationValue } = props;

  const containerStyle = useAnimatedStyle(() => {
    const backgroundColor = interpolateColor(animationValue.value, [-1, 0, 1], ["transparent", colors.accent, "transparent"]);

    return {
      backgroundColor,
      borderWidth: 1,
      marginHorizontal: 12,
      borderColor: colors.accent,
      padding: 24,
      borderRadius: 24,
    };
  }, [animationValue]);

  const textStyle = useAnimatedStyle(() => {
    const color = interpolateColor(animationValue.value, [-1, 0, 1], [colors.accent, colors.whiteText, colors.accent]);

    return {
      ...fonts.bold,
      color,
    };
  }, [animationValue]);

  const textStyle2 = useAnimatedStyle(() => {
    const color = interpolateColor(animationValue.value, [-1, 0, 1], [colors.accent, colors.whiteText, colors.accent]);

    return {
      ...fonts.regular,
      color,
    };
  }, [animationValue]);

  const textStyle3 = useAnimatedStyle(() => {
    const color = interpolateColor(animationValue.value, [-1, 0, 1], [colors.accent, colors.whiteText, colors.accent]);

    return {
      ...fonts.regular,
      color,
    };
  }, [animationValue]);

  const textStyle4 = useAnimatedStyle(() => {
    const color = interpolateColor(animationValue.value, [-1, 0, 1], [colors.accent, colors.whiteText, colors.accent]);

    return {
      ...fonts.regular,
      color,
    };
  }, [animationValue]);

  const getOpenTermType = (ib?: string) => {
    if (ib === "Y") return t("SAVING_SO_TIET_ONLINE");
    return t("SAVING_SO_TIET_TAI_QUAY");
  };
  return (
    <Animated.View style={containerStyle}>
      <Pressable style={{ flex: 1 }} onPress={onPressItem}>
        <Animated.Text style={textStyle}>{getOpenTermType(item?.IB)}</Animated.Text>
        <StackSpacing size="small" />
        <Animated.Text style={textStyle2}>{item?.ACCOUNTTYPENAME}</Animated.Text>
        <StackSpacing size="small" />
        <Animated.Text style={textStyle3}>{item?.ACCOUNTNO}</Animated.Text>
        <StackSpacing size="small" />
        <Animated.Text style={textStyle4}>{formatCurrency(item?.CURRENTBALANCE, item?.CURRENCYCODE)}</Animated.Text>
      </Pressable>
    </Animated.View>
  );
};

export default TermScroll;
